import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Certificates from "./Certificates";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import CodingPlateform from "./CodingPlateform";
import Projects from "../Projects/Projects";


function About() {
  
  return (
    <section>
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Coding profiles </strong>
        </h1>
          <CodingPlateform/>
        <h1 className="project-heading">
          My <strong className="purple">Certifications/Badges </strong>
        </h1>
        <Certificates/>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />
        {/* <Github /> */}
      </Container>
    </Container>
    {/* <Projects /> */}
    </section>
  );
}

export default About;
